<template>
  <div class="school_right">
    <div class="school_right_top flex Flexalign mar_bottom_10">
      <el-image class="avatar" :src="imgPath(courseDetail.shopLogo)"></el-image>
      <div class="flex flexcolumn mar_left_10 flex-1 organization_info">
        <div class="flex Flexalign FlexBetween organization_info_top">
          <div class="organization_name toverflow">{{ courseDetail.shopName }}</div>
          <div class="collect_btn flex Flexalign Flexjustify cursor_pointer" v-if="!shopCollected"
            @click="collectShopCourse(true)">
            <el-image class="collect_icon" :src="imgPath('collect_icon.png')"></el-image>
            <div>关注</div>
          </div>
          <div class="flex btn btn_follow btn_followed Flexjustify Flexalign cursor_pointer" v-if="shopCollected"
              @click="collectShopCourse(false)">
              <div>已关注</div>
            </div>
        </div>
        <div class="organization_desc toverflows toverflow2">
          {{ courseDetail.shopBrief }}
        </div>
      </div>
    </div>
    <!-- 课程信息 -->
    <!-- <classInfo v-if="!hideClass"></classInfo> -->
    <!-- 课件资料 -->
    <classWare v-if="!hideClass"></classWare>
    <courseOutline v-show="showCourseOutline && !hideClass" :courseDetail="courseDetail" :courseId="courseId" @getCourseVideo="getCourseVideo"></courseOutline>
    <recommendCourseList></recommendCourseList>
  </div>
</template>

<script>
import courseOutline from "@/components/course/courseOutline.vue";
import recommendCourseList from "@/views/course/components/recommendCourseList.vue";
// import classInfo from './classInfo.vue';
import classWare from './classWare.vue';
export default {
  name: "GjkcH5SchoolRight",
  components: {
    courseOutline,
    recommendCourseList,
    // classInfo,
    classWare
  },
  props: {
    showCourseOutline: {},
    courseId: {},
    courseDetail: {},
    hideClass:{}
  },
  watch:{
    courseDetail:{
      handler(){
        this.getShopCollectInfo();
      },
      deep:true
    }
  },
  data() {
    return {
      rankList: [],
      shopCollected: false, // 是否收藏机构
      collectParams: {
        collectType: 3,
        associatedIds: "",
      },
    };
  },

  mounted() {
    this.getShopCollectInfo();
  },

  methods: {
    getCourseVideo(url) {
      this.$emit('getCourseVideoUrl', url)
    },
    // 机构收藏关系
    getShopCollectInfo() {
      if(this.$Tools.empty(this.courseDetail)){
        return
      }
      this.collectParams.associatedIds = this.courseDetail.shopId;
      this.collectParams.collectType = 2;
      this.$Api.course
        .getCollectInfo(this.collectParams)
        .then((res) => {
          const idx = res.data.data.findIndex((item) => item == this.courseDetail.shopId);
          if (idx != -1) {
            this.shopCollected = true;
          } else {
            this.shopCollected = false;
          }
        })
        .catch(() => {
        });
    },

    // 收藏机构
    collectShopCourse(flag) {
      this.$Api.shop.collectShop({ shopId: this.courseDetail.shopId }).then((res) => {
        console.log(res);
        if (flag) {
          this.$Dialog.toast("关注成功");
        } else {
          this.$Dialog.toast("已取消关注", { type: "warning" });
        }
        this.getShopCollectInfo();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.school_right {
  .school_right_top {
    width: 330px;
    height: 97px;
    background: #ffffff;
    border-radius: 10px;
    padding: 10px 20px;
    box-sizing: border-box;

    .avatar {
      width: 54px;
      height: 54px;
      border-radius: 50%;
    }

    .organization_info {
      .organization_info_top {
        .organization_name {
          font-weight: bold;
          font-size: 18px;
          color: #333333;
          max-width: 100px;
        }

        .collect_btn {
          width: 78px;
          height: 30px;
          background: linear-gradient(90deg, #00d5c2, #00d498);
          border-radius: 15px;
          line-height: 30px;
          text-align: center;
          color: #ffffff;

          .collect_icon {
            width: 18px;
            height: 18px;
            margin-right: 5px;
          }
        }
        .btn_followed {
          width: 94px;
          height: 36px;
          background: #F8F8F8;
          border-radius: 18px;
          color: #999999;
        }
      }

      .organization_desc {
        margin-top: 5px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        color: #999999;
        line-height: 22px;
      }
    }
  }
}
</style>
